import { Token } from '@kb3d/models/classes/token';
import { LinearPatternGeometryProcessor } from './geometry-processor/linear-pattern-geometry';
import { PatternRenderer } from './pattern';

export class LinearPatternRenderer extends PatternRenderer {
    modelToken = Token.LinearPatternFeature;
    processor = new LinearPatternGeometryProcessor(this.scene);
}
